import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { switchMap, take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.authService.fetchAndCacheRoles(false).pipe(
      switchMap(() => this.authService.getUserObj()),
      take(1),
      map((userObj) => {
        if (userObj?.WHITELISTING_MAINTENANCE_ENABLE === true) {
          this.router.navigate(['/maintenance']);
          return false;
        }
        return true;
      })
    );
  }
}
